// extracted by mini-css-extract-plugin
module.exports = {"hidden":"companyTopButton_hidden__8KACD","textEmphasis":"companyTopButton_textEmphasis__H7uR9","btnTop":"companyTopButton_btnTop__tFELw"};